import { DEFAULT_MIDDLE_DIALOG_WIDTH } from '@abb-procure/constants';
import {
  IdNameDescriptionModel,
  IdNameModel,
  LookupDataState,
} from '@abb-procure/data';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  booleanAttribute,
  inject,
  output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import type {
  LeverDialog,
  LeverDialogData,
} from '../lever-dialog/lever-dialog.component';

@Component({
  selector: 'procure-chess-board',
  templateUrl: './chess-board.component.html',
  styleUrl: './chess-board.component.scss',
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChessBoard {
  @Input({ required: true }) protected selectedLever?: number | null;

  @Input({ required: true, transform: booleanAttribute })
  protected showMode: boolean = false;

  protected readonly selectedLeverChange = output<IdNameModel>();

  protected readonly levers = inject(LookupDataState).strategyDimensionLevers;

  private readonly dialog = inject(MatDialog);

  protected async openLeverDialog(
    event: MouseEvent,
    lever: IdNameDescriptionModel,
  ): Promise<void> {
    event.preventDefault();

    const module = await import('../lever-dialog/lever-dialog.component');

    this.dialog.open<LeverDialog, LeverDialogData, undefined>(
      module.LeverDialog,
      {
        width: DEFAULT_MIDDLE_DIALOG_WIDTH,
        data: {
          lever,
        },
        panelClass: ['lever-dialog'],
      },
    );
  }
}
